import { render, staticRenderFns } from "./PartsMaterials.vue?vue&type=template&id=b047f112&scoped=true&"
import script from "./PartsMaterials.vue?vue&type=script&lang=js&"
export * from "./PartsMaterials.vue?vue&type=script&lang=js&"
import style0 from "./PartsMaterials.vue?vue&type=style&index=0&id=b047f112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b047f112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
